import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5486_2331)">
      <rect
        width="24"
        height="24"
        rx="4"
        transform="matrix(-1 0 0 1 24.0005 0)"
        fill="#11181C"
      />
      <g filter="url(#filter0_d_5486_2331)">
        <path
          d="M13.597 7.30273H16.6972V10.4342V13.5657V16.6972H13.597H13.5657H12.8141V13.5658H11.217V16.6972H10.4342H7.30273V13.5658V10.4342V7.30273H10.4341H11.217V10.4342H12.8141V7.30273H13.5657H13.597Z"
          fill="#EEEDEE"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.08423 4.08423H19.9158V10.3679H18.3011V5.69892H5.69892V18.3011H18.3011V13.5904H19.9158V19.9158H4.08423V4.08423Z"
        fill="#EEEDEE"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_5486_2331"
        x="-16.3906"
        y="-11.6519"
        width="56.7812"
        height="56.7811"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4.73867" />
        <feGaussianBlur stdDeviation="11.8467" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.2125 0 0 0 0 0.06375 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5486_2331"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5486_2331"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_5486_2331">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
